import { z } from 'zod';
import { UuidString } from '../../primitives.js';

/**
 * BE-3 — denorm-bundle проектов (code+name) для payload задач.
 *
 * НЕ мутирует `Task` (project_id остаётся сырым UUID-ref). Отдельная
 * UUID-keyed карта на уровне ответа (как `assignee_directory`) — FE рендерит
 * project-chip с переходом в проект по project_id без N+1.
 *
 * Structural-only (i18n invariant): code/name — данные, не freeform UI-текст.
 * code nullable (проект может быть без кода).
 */

export const ProjectDirectoryEntry = z.object({
  project_id: UuidString,
  code: z.string().nullable(),
  name: z.string().min(1),
});
export type ProjectDirectoryEntry = z.infer<typeof ProjectDirectoryEntry>;

export const ProjectDirectory = z.array(ProjectDirectoryEntry);
export type ProjectDirectory = z.infer<typeof ProjectDirectory>;
